import { readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

const gapOptOutService = axios.create({
  baseURL: readFromEnv('GAP_SERVICE_URL'),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export const submitGapOptOutRequest = async (data: { orderId: string }) =>
  await gapOptOutService.request<unknown>({
    url: `/gap/opt-out`,
    data: data,
    method: 'POST',
  })
